
import axios from 'axios';

import { store } from '../store';
import { logout, updateUserDetail } from '../store/userSlice';

const BASE_URL = import.meta.env.VITE_BASE_URL;

const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

console.log(BASE_URL)
console.log(timezone)

const api = axios.create({
    baseURL: BASE_URL,
    timeout: 10000,
});

api.interceptors.request.use(
    (config) => {
        const token = store.getState().user.token;
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        if (timezone) {
            config.headers['X-Timezone'] = timezone;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    (response) => {
        const { is_premium, is_profile_completed } = response.data as any

        if ([true, false].includes(is_premium)) {
            store.dispatch(updateUserDetail({ is_premium }))
        }

        if ([false, true].includes(is_profile_completed)) {
            localStorage.setItem('is_profile_completed', JSON.stringify(is_profile_completed));
        }

        return response
    },
    (error) => {
        if (error.response) {
            console.error('Error response:', error.response);
            if ([401, 403].includes(error.response.status)) {
                console.error("Loggin out")
                store.dispatch(logout());
                localStorage.removeItem("is_profile_completed")
            }
        }
        return Promise.reject(error);
    }
);


export default api;